module.exports = __webpack_public_path__ + "img/saudi_arabia.00e36975.svg";